// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M32.6 22.7L17.4 7.5c-.2-.2-.5-.4-.9-.4-.3 0-.6.1-.9.4L.5 22.7c-.3.3-.3.8 0 1.1l.9.9c.1.1.3.2.5.2s.4-.1.5-.2l14.2-14.1 14.1 14.1c.3.3.8.3 1.1 0l.9-.9c.2-.4.2-.8-.1-1.1z"/></svg>;
};

export default React.memo(CaretUp);
